import React from "react";
import { useSelector } from "react-redux";
import { Link, NavLink, useLocation } from "react-router-dom";
import iconHome from "../../assets/images/icon-home.png";
import iconRanking from "../../assets/images/icon-ranking.png";
import iconDepositar from "../../assets/images/icon-depositar.png";
import iconChat from "../../assets/images/icon-chat.png";
import iconPerfil from "../../assets/images/icon-perfil.png";
import iconMobile from "../../assets/images/icon-mobile.png";
import { hapticLight, hapticMedium } from "../../utils/haptic";
import "./MenuMobile.scss";

function MobileMenu() {
  const token = useSelector((state) => state.session.token);
  const location = useLocation();
  const isOnSignup = location.pathname.startsWith("/new-account");

  const loggedInNav = (
    <nav className="nav-footer-mobile">
      <Link to="/download" className="upper-info-banner" onClick={hapticLight}>
        <span>Baixe o app</span>
        <img src={iconMobile} alt="" className="banner-icon-img" />
      </Link>
      <ul>
        <li>
          <NavLink to="/" end onClick={hapticLight}>
            <div className="labelIcon">
              <span>
                <img src={iconHome} alt="Home" className="nav-icon-img" />
              </span>
            </div>
            <div className="labelMenu">
              <p>Home</p>
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink to="/ranking" onClick={hapticLight}>
            <div className="labelIcon">
              <span>
                <img src={iconRanking} alt="Ranking" className="nav-icon-img" />
              </span>
            </div>
            <div className="labelMenu">
              <p>Ranking</p>
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink to="/payment" onClick={hapticMedium}>
            <div className="labelIcon">
              <span>
                <img src={iconDepositar} alt="Depositar" className="nav-icon-img" />
              </span>
            </div>
            <div className="labelMenu">
              <p>Depositar</p>
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink to="/withdraw" onClick={hapticMedium}>
            <div className="labelIcon">
              <span>
                <i className="fa-solid fa-sack-dollar"></i>
              </span>
            </div>
            <div className="labelMenu">
              <p>Sacar</p>
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink to="/chatApp" onClick={hapticLight}>
            <div className="labelIcon">
              <span>
                <img src={iconChat} alt="Chat" className="nav-icon-img" />
              </span>
            </div>
            <div className="labelMenu">
              <p>Chat</p>
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink to="/profile" onClick={hapticLight}>
            <div className="labelIcon">
              <span>
                <img src={iconPerfil} alt="Perfil" className="nav-icon-img" />
              </span>
            </div>
            <div className="labelMenu">
              <p>Perfil</p>
            </div>
          </NavLink>
        </li>
      </ul>
    </nav>
  );

  const loggedOutNav = (
    <nav className="nav-footer-mobile nav-footer-mobile--guest">
      <ul>
        <li>
          <Link to="/" onClick={hapticLight}>
            <div className="labelIcon">
              <span>
                <img src={iconHome} alt="Início" className="nav-icon-img" />
              </span>
            </div>
            <div className="labelMenu">
              <p>Início</p>
            </div>
          </Link>
        </li>
        {!isOnSignup && (
          <li className="nav-footer-mobile__cta-item">
            <Link
              to="/new-account"
              onClick={hapticMedium}
              className="nav-footer-mobile__cta"
            >
              Cadastrar
            </Link>
          </li>
        )}
        <li>
          <Link to="/login" onClick={hapticLight}>
            <div className="labelIcon">
              <span>
                <img src={iconPerfil} alt="Entrar" className="nav-icon-img" />
              </span>
            </div>
            <div className="labelMenu">
              <p>Entrar</p>
            </div>
          </Link>
        </li>
      </ul>
    </nav>
  );

  return <>{token ? loggedInNav : loggedOutNav}</>;
}

export default MobileMenu;
